// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WomanOutlinedSvg from "@ant-design/icons-svg/es/asn/WomanOutlined";
import AntdIcon from '../components/AntdIcon';

var WomanOutlined = function WomanOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WomanOutlinedSvg
  }));
};

WomanOutlined.displayName = 'WomanOutlined';
export default React.forwardRef(WomanOutlined);